import { useEffect, useMemo } from 'react';
import { PaymentMethodType } from 'orderme-api-integration-client';
import { PaymentClient } from '../../helpers/client';

function loadGooglePay(): void {
  window.googlePayClient = null;

  const script = document.createElement('script');
  script.id = 'google-pay-js';
  script.async = true;
  script.src = 'https://pay.google.com/gp/p/js/pay.js';
  script.onload = () => {
    window.googlePayClient = new google.payments.api.PaymentsClient({
      environment: 'PRODUCTION',
    });
  };
  document.head.appendChild(script);
}

export function GooglePayScript(): React.JSX.Element | null {
  const paymentClient: PaymentClient = useMemo(() => new PaymentClient(), []);

  useEffect(() => {
    if (document.getElementById('google-pay-js')) {
      return;
    }

    paymentClient
      .get()
      .then((methods) => {
        const hasGooglePay = methods?.some((m) => m.type === PaymentMethodType.GooglePay);
        if (!hasGooglePay) {
          return;
        }

        loadGooglePay();
      })
      .catch((exception) => {
        console.error('Not possible to load payment methods', exception);
      });
  }, [paymentClient]);

  return null;
}
